module.exports = __webpack_public_path__ + "static/media/bg-topo-dark-blue.48cdc4cd.png";